import { Box, Stack, Typography } from "@mui/material";
import { isError } from "util";

interface TintedMetricIconProps {
  src: string;
  alt: string;
  isError: boolean;
}

export const TintedMetricIcon = ({ src, alt, isError }: TintedMetricIconProps) => {
  return (
    <Box
      sx={{
        width: 50,
        height: 50,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#ecfdf564",
        borderRadius: "40px",
        p: 0,
        boxShadow:
          "inset 0 0 16.94px rgba(226, 226, 226, 0.28), inset 0 0 1.06px 4.24px rgba(255, 255, 255, 0.18)",
      }}>
      <Box
        component="span"
        role="img"
        aria-label={alt}
        sx={{
          width: 36,
          height: 36,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: isError ? "#FF1400" : "#009300",
          borderRadius: "50%",
          WebkitMaskImage: `url(${src})`,
          maskImage: `url(${src})`,
          WebkitMaskRepeat: "no-repeat",
          maskRepeat: "no-repeat",
          WebkitMaskPosition: "center",
          maskPosition: "center",
          WebkitMaskSize: "60%",
          maskSize: "60%",
        }}
      />
    </Box>
  );
};

interface SpeedMetricResultProps {
  icon: string;
  label: string;
  value: number | string;
  unit: string;
  isError: boolean;
  subText: string;
}

const SpeedMetricResult = ({ icon, label, value, unit, isError, subText }: SpeedMetricResultProps) => {
  return (
    <Stack zIndex={1} direction={"row"} alignItems={"center"} gap={2} px={2}>
      <TintedMetricIcon src={icon} alt={label} isError={isError} />
      <Stack alignItems={"center"} justifyContent={"center"}>
        <Typography color={"#64748B"} fontSize={"13px"}>
          {label}
        </Typography>
        <Stack direction={"row"} alignItems={"baseline"} gap={0.5}>
          <Typography fontWeight={"bold"} fontSize={"28px"} color={"#000"}>
            {value}
          </Typography>
          <Typography fontSize={"13px"} color={"#64748B"}>
            {" "}{unit}
          </Typography>
          
        </Stack>
       {!isError && (
        <Typography
          color={"#64748B"}
          sx={{
            fontFamily: "Inter",
            fontWeight: 500,
            fontSize: "11px",
            lineHeight: "14px",
            letterSpacing: "0.31px",
            textAlign: "center",
            verticalAlign: "middle",
            textTransform: "capitalize",
          }}>
          {subText}
        </Typography>)}
      </Stack>
    </Stack>
  );
};

export default SpeedMetricResult;
